export const isBrowser = () => typeof window !== 'undefined'

export const getLocalObject = key =>
  isBrowser() && window.localStorage.getItem(key)
    ? JSON.parse(window.localStorage.getItem(key))
    : {}

export const setLocalObject = (key, obj) => isBrowser() && window.localStorage.setItem(key, JSON.stringify(obj))
